import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatherIconDirective } from '../../directives/feather-icon.directive';
import { HELP_TOPICS } from '../../data/help-topics.registry';
import { HelpService } from '../../services/help.service';
import { LanguageService } from '../../services/language.service';
import { hasHelpGuide } from '../help-guides/help-guide.components';
import { CustomerListHelpGuideComponent } from '../customer-list-help-guide/customer-list-help-guide.component';
import { ChatScreenHelpGuideComponent } from '../chat-screen-help-guide/chat-screen-help-guide.component';
import { DashboardHelpGuideComponent } from '../help-guides/dashboard-help-guide/dashboard-help-guide.component';
import { SettingsHelpGuideComponent } from '../help-guides/settings-help-guide/settings-help-guide.component';
import { FollowupListHelpGuideComponent } from '../help-guides/followup-list-help-guide/followup-list-help-guide.component';
import { RecurringFollowupListHelpGuideComponent } from '../help-guides/recurring-followup-list-help-guide/recurring-followup-list-help-guide.component';
import { RecycleBinHelpGuideComponent } from '../help-guides/recycle-bin-help-guide/recycle-bin-help-guide.component';
import { PendingTransactionsHelpGuideComponent } from '../help-guides/pending-transactions-help-guide/pending-transactions-help-guide.component';
import { CustomerStatementHelpGuideComponent } from '../help-guides/customer-statement-help-guide/customer-statement-help-guide.component';
import { CommonStatementHelpGuideComponent } from '../help-guides/common-statement-help-guide/common-statement-help-guide.component';
import { UserProfileHelpGuideComponent } from '../help-guides/user-profile-help-guide/user-profile-help-guide.component';
import { CustomerProfileHelpGuideComponent } from '../help-guides/customer-profile-help-guide/customer-profile-help-guide.component';
import { AddCustomerHelpGuideComponent } from '../help-guides/add-customer-help-guide/add-customer-help-guide.component';
import { TransferGroupHelpGuideComponent } from '../help-guides/transfer-group-help-guide/transfer-group-help-guide.component';
import { PendingTransactionsDialogHelpGuideComponent } from '../help-guides/pending-transactions-dialog-help-guide/pending-transactions-dialog-help-guide.component';
import { EntryCreateHelpGuideComponent } from '../help-guides/entry-create-help-guide/entry-create-help-guide.component';
import { EntryEditHelpGuideComponent } from '../help-guides/entry-edit-help-guide/entry-edit-help-guide.component';
import { EntryFollowupHelpGuideComponent } from '../help-guides/entry-followup-help-guide/entry-followup-help-guide.component';
import { EntryRecurringPaymentHelpGuideComponent } from '../help-guides/entry-recurring-payment-help-guide/entry-recurring-payment-help-guide.component';
import { FollowupDialogHelpGuideComponent } from '../help-guides/followup-dialog-help-guide/followup-dialog-help-guide.component';
import { RecurringFollowupDialogHelpGuideComponent } from '../help-guides/recurring-followup-dialog-help-guide/recurring-followup-dialog-help-guide.component';
import { AiVoiceHelpGuideComponent } from '../help-guides/ai-voice-help-guide/ai-voice-help-guide.component';
import { AiChatHelpGuideComponent } from '../help-guides/ai-chat-help-guide/ai-chat-help-guide.component';
import { BusinessPopupHelpGuideComponent } from '../help-guides/business-popup-help-guide/business-popup-help-guide.component';

@Component({
  selector: 'app-help-modal',
  standalone: true,
  imports: [
    CommonModule,
    FeatherIconDirective,
    CustomerListHelpGuideComponent,
    ChatScreenHelpGuideComponent,
    DashboardHelpGuideComponent,
    SettingsHelpGuideComponent,
    FollowupListHelpGuideComponent,
    RecurringFollowupListHelpGuideComponent,
    RecycleBinHelpGuideComponent,
    PendingTransactionsHelpGuideComponent,
    CustomerStatementHelpGuideComponent,
    CommonStatementHelpGuideComponent,
    UserProfileHelpGuideComponent,
    CustomerProfileHelpGuideComponent,
    AddCustomerHelpGuideComponent,
    TransferGroupHelpGuideComponent,
    PendingTransactionsDialogHelpGuideComponent,
    EntryCreateHelpGuideComponent,
    EntryEditHelpGuideComponent,
    EntryFollowupHelpGuideComponent,
    EntryRecurringPaymentHelpGuideComponent,
    FollowupDialogHelpGuideComponent,
    RecurringFollowupDialogHelpGuideComponent,
    AiVoiceHelpGuideComponent,
    AiChatHelpGuideComponent,
    BusinessPopupHelpGuideComponent
  ],
  templateUrl: './help-modal.component.html',
  styleUrls: ['./help-modal.component.css']
})
export class HelpModalComponent {
  private helpSvc = inject(HelpService);
  private langSvc = inject(LanguageService);

  readonly isOpen = this.helpSvc.isOpen;
  readonly topic = this.helpSvc.topic;

  readonly definition = computed(() => {
    this.langSvc.currentLang();
    const id = this.topic();
    return id ? HELP_TOPICS[id] : null;
  });

  readonly hasGuide = computed(() => hasHelpGuide(this.topic()));

  t(key: string): string {
    return this.langSvc.t(key);
  }

  close(): void {
    this.helpSvc.close();
  }
}
